export const MenuList = props => (
  <div
    className="relative py-1 rounded-md shadow-lg bg-surface-50 border border-surface-200/50 max-h-12 overflow-auto"
    style={{ maxHeight: '250px' }}
    {...props}
  />
)
